import { PIP_IFRAME_NAME } from './constants'

/**
 * Get PIP iframe from window.frames. This should have no dependencies.
 * @returns
 */
export function getPIPIframe(): Window | undefined {
  return typeof window !== 'undefined' && window.frames[PIP_IFRAME_NAME]
}
